import * as api from '../util/apis';
import { ENV } from '../constants/Constants';
import moment from 'moment';
import {
	campaignResponseSummation,
	getReportForViewership,
	ViewershipResult,
} from 'jsonutils/reports';

export const getCampaignReportsData = async (respData: any) => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.reports +
				'/campaignreport?' +
				'campaignId=' +
				respData.campaignId +
				'&startDate=' +
				moment(respData.startDate).format('YYYY-MM-DD') +
				'&endDate=' +
				moment(respData.endDate).format('YYYY-MM-DD'),
		);

		const result = campaignResponseSummation(resp.data.data);
		resp.data.data.push(result);
		//const barchartData: any = getCampaignBarChartData(resp.data.data);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getAdvertisementReportsData = async (respData: any) => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.reports +
				'/adplayreport?' +
				'adId=' +
				respData.adId +
				'&startDate=' +
				moment(respData.startDate).format('YYYY-MM-DD') +
				'&endDate=' +
				moment(respData.endDate).format('YYYY-MM-DD'),
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getViewershipReportsData = async (campId: number) => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.reports + '/viewership-report?' + 'campaignId=' + campId,
		);
		const data: ViewershipResult = getReportForViewership(resp.data.data);
		return Promise.resolve(data);
	} catch (error) {
		return Promise.reject(error);
	}
};
